var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetigation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_355_4714)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 48,
    height: 48,
    rx: 10,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 47,
    height: 47,
    rx: 9.5,
    stroke: "#EAECF0",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 35.75H23C17.57 35.75 15.25 33.43 15.25 28V22C15.25 16.57 17.57 14.25 23 14.25H29C34.43 14.25 36.75 16.57 36.75 22V26C36.75 26.41 36.41 26.75 36 26.75C35.59 26.75 35.25 26.41 35.25 26V22C35.25 17.39 33.61 15.75 29 15.75H23C18.39 15.75 16.75 17.39 16.75 22V28C16.75 32.61 18.39 34.25 23 34.25H27C27.41 34.25 27.75 34.59 27.75 35C27.75 35.41 27.41 35.75 27 35.75Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3301 28.24C21.1701 28.24 21.0101 28.19 20.8701 28.08C20.5401 27.83 20.4801 27.36 20.7301 27.03L23.1101 23.94C23.4001 23.57 23.8101 23.33 24.2801 23.27C24.7501 23.21 25.2101 23.34 25.5801 23.63L27.4101 25.07C27.4801 25.13 27.5501 25.12 27.6001 25.12C27.6401 25.12 27.7101 25.1 27.7701 25.02L30.0801 22.04C30.3301 21.71 30.8001 21.65 31.1301 21.91C31.4601 22.16 31.5201 22.63 31.2601 22.96L28.9501 25.94C28.6601 26.31 28.2501 26.55 27.7801 26.6C27.3201 26.66 26.8501 26.53 26.4901 26.24L24.6601 24.8C24.5901 24.74 24.5101 24.74 24.4701 24.75C24.4301 24.75 24.3601 24.77 24.3001 24.85L21.9201 27.94C21.7801 28.14 21.5601 28.24 21.3301 28.24Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.26 35.75C33.91 35.75 33.46 35.64 32.93 35.32L32.68 35.17C32.61 35.13 32.3999 35.13 32.3299 35.17L32.0799 35.32C30.9299 36.01 30.2 35.72 29.88 35.48C29.55 35.24 29.04 34.64 29.34 33.32L29.39 33.11C29.41 33.03 29.3499 32.84 29.2999 32.78L28.95 32.43C28.36 31.83 28.1299 31.13 28.3299 30.5C28.5299 29.88 29.12 29.44 29.95 29.3L30.3299 29.24C30.3999 29.22 30.5399 29.12 30.5799 29.05L30.8599 28.48C31.2499 27.69 31.85 27.24 32.51 27.24C33.17 27.24 33.77 27.69 34.16 28.48L34.44 29.04C34.48 29.11 34.62 29.21 34.69 29.23L35.07 29.29C35.9 29.43 36.49 29.87 36.69 30.49C36.89 31.11 36.67 31.81 36.07 32.42L35.72 32.77C35.67 32.83 35.61 33.02 35.63 33.1L35.68 33.31C35.98 34.63 35.47 35.23 35.14 35.47C34.96 35.61 34.67 35.75 34.26 35.75ZM32.49 28.75C32.48 28.76 32.34 28.86 32.2 29.15L31.92 29.72C31.68 30.21 31.1099 30.63 30.5799 30.72L30.2 30.78C29.88 30.83 29.77 30.94 29.76 30.96C29.76 30.98 29.79 31.14 30.02 31.37L30.37 31.72C30.78 32.14 30.9899 32.86 30.8599 33.43L30.81 33.64C30.72 34.03 30.76 34.2 30.78 34.26C30.81 34.24 30.98 34.22 31.31 34.02L31.56 33.87C32.11 33.54 32.9 33.54 33.45 33.87L33.7 34.02C34.11 34.27 34.28 34.24 34.29 34.24C34.25 34.24 34.3 34.04 34.21 33.64L34.16 33.43C34.03 32.85 34.24 32.14 34.65 31.72L35 31.37C35.23 31.14 35.26 30.98 35.26 30.95C35.25 30.93 35.14 30.83 34.82 30.77L34.44 30.71C33.9 30.62 33.34 30.2 33.1 29.71L32.82 29.15C32.66 28.85 32.52 28.76 32.49 28.75Z",
    fill: "#292D32"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_355_4714",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_355_4714"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_355_4714",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetigation);
export default __webpack_public_path__ + "static/media/metigation.f78baf447c4a74afccef18c1872f4017.svg";
export { ForwardRef as ReactComponent };